module.exports = __webpack_public_path__ + "img/Ptuapp9.b834f402.png";